/* global Turbolinks */

import { postInit } from "./platin";
import { keyToSelector } from "./locations";
import $ from "jquery";

function prepareLocationMap() {
  const container = $("#locations-map"),
    svg = $("svg", container),
    locKeyArrays = container.data("locs");
  let missionIndex = 0;

  $("g.occupied").removeClass("occupied");
  $("g.active").removeClass("active");

  for (let locKeys of locKeyArrays) {
    for (let key of locKeys) {
      const g = $(`g[id='${keyToSelector(key)}']`);
      if (key.match(/^EB/)) {
        g.addClass("active");
      } else if (key.match(/^FL/)) {
        g.addClass("poweroff");
      } else {
        if (g.hasClass("occupied")) {
          g.addClass("conflict");
        }
        g.addClass(`occupied mission-${missionIndex}`);
      }
    }
    missionIndex = missionIndex + 1;
  }
  $(svg).parent().tooltip({
    selector: "[title]",
    container: "#locations-map"
  });

  $(svg).click(() => {
    svg.toggleClass("highlighted");
  });

}

function initCockpit() {
  const svg = $("#locations-map svg");
  prepareLocationMap();

  $("#shift_type, #date").change(function () {
    const params = {
      date: $("#date").val(),
      shift_type: $("#shift_type").val()
    };
    Turbolinks.visit(`/timeshifts/cockpit?${$.param(params)}`);
  });

  $("tr.highlight-mission").mouseover(function () {
    const index = $(this).data("mission-index");
    svg.addClass(`highlight-mission-${index}`);
  });
  $("tr.highlight-mission").mouseout(function () {
    const index = $(this).data("mission-index");
    svg.removeClass(`highlight-mission-${index}`);
  });

  /* extracts the indices from mission-n classes on el as an array of numbers */
  function getMissionIndices(el) {
    return $(el).attr("class")
      .split(" ")
      .filter(s => s.match(/^mission-\d+$/))
      .map(s => parseInt(s.match(/^mission-(\d+)$/)[1]));
  }

  function highlightTableRow(hoverOnEl, on) {
    const missionIndices = getMissionIndices(hoverOnEl);
    for (let missionIndex of missionIndices) {
      if (on) {
        $(`tr.highlight-mission[data-mission-index="${missionIndex}"]`).addClass("highlighted");
      } else {
        $(`tr.highlight-mission[data-mission-index="${missionIndex}"]`).removeClass("highlighted");
      }
    }

  }

  $("svg .occupied").mouseover(function () { highlightTableRow(this, true); });
  $("svg .occupied").mouseout(function () { highlightTableRow(this, false); });
}

postInit("timeshifts#cockpit", initCockpit);